import PropTypes from 'prop-types';
import React from 'react';
import compose from '../../hoc/compose';

var ProgressBar = function ProgressBar(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: "control-progress-bar",
    "data-aid": props.automationId,
    "data-hook": props.dataHook
  }, /*#__PURE__*/React.createElement("div", {
    className: "progress-line-container",
    style: {
      width: props.hideText ? '100%' : 'calc(100% - ' + (!isNaN(props.progressMax) && props.progressMax > 99 ? 51 : 39) + 'px)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "progress-line",
    style: {
      width: props.progress / (isNaN(props.progressMax) ? 1 : props.progressMax / 100) + '%'
    }
  })), !props.hideText && /*#__PURE__*/React.createElement("div", {
    "data-hook": 'progress-text',
    className: "progress-text"
  }, props.progress, isNaN(props.progressMax) ? '%' : '/' + props.progressMax));
};

ProgressBar.displayName = 'ProgressBar';
ProgressBar.propTypes = {
  /** Applies a data-hook HTML attribute that can be used in the tests */
  dataHook: PropTypes.string,

  /** Set the progress */
  progress: PropTypes.number.isRequired,

  /** Override the max progress with a numeric progress, default is 100% */
  progressMax: PropTypes.number,

  /** Hide the progress text */
  hideText: PropTypes.bool
};
ProgressBar.defaultProps = {
  hideText: false
};
export default compose(ProgressBar);